import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  List,
  IconButton,
} from '@material-ui/core';
import axios from 'api/axios';
import React from 'react';
import { useQuery } from 'react-query';
import CallingListItem from './CallingListItem';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const CallsListModal = ({ onClose, open, id }) => {
  const classes = useStyles();
  const fetchCalls = async () => {
    const { data } = await axios.get(`/api/v1/admin/freight/order/${id}/calls`);
    return data;
  };
  const { data, isLoading } = useQuery(['callsList', id], () => fetchCalls());

  return (
    <Dialog fullWidth onClose={onClose} open={open}>
      {!isLoading ? (
        <>
          <DialogTitle>
            <div className="d-flex justify-content-between align-items-between">
              <span>لیست تماس ها</span>
              <IconButton aria-label="close" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>

          <DialogContent className="text-center p-0">
            {data.length === 0 ? (
              <>
                <DialogContentText>تماسی وجود ندارد.</DialogContentText>
                <Button
                  fullWidth
                  className="position-sticky"
                  onClick={onClose}
                  color="secondary"
                  variant={'contained'}
                >
                  بستن
                </Button>
              </>
            ) : (
              <div>
                <List className={classes.root}>
                  {data.map((item, i) => (
                    <CallingListItem
                      key={i}
                      call={item}
                      driver={item.driver}
                      id={id}
                    />
                  ))}
                </List>
                <Button
                  fullWidth
                  className="position-sticky"
                  onClick={onClose}
                  color="secondary"
                  variant={'contained'}
                >
                  بستن
                </Button>
              </div>
            )}
          </DialogContent>
        </>
      ) : (
        <div className="p-3 text-center">
          <CircularProgress />
        </div>
      )}
    </Dialog>
  );
};

export default CallsListModal;
